import { render, staticRenderFns } from "./FeiShuEventList.vue?vue&type=template&id=2c478751&scoped=true"
import script from "./FeiShuEventList.vue?vue&type=script&lang=js"
export * from "./FeiShuEventList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c478751",
  null
  
)

export default component.exports